import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {map} from 'rxjs/operators';
import {Subject, Observable} from 'rxjs';

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class RetroalimentacionService {

  dataEvento: any;

  private subject = new Subject<any>();

  constructor(private http: HttpClient) {
  }

  get evento() {
    return this.dataEvento;
  }

  set evento(evento) {
    this.dataEvento = evento;
  }

  setEstadoEvaluacionCriterio(obj, accion): Observable<any> {
    if (accion === 'post') {
      return this.http.post(`${API_URL}/api/v2/EventosAlumno/criterio`, obj);
    }
    if (accion === 'delete') {
    }
  }

  createEvaluation(unidadEventoMateriaId, alumnoId) {
    return this.http.post<any>(`${API_URL}/api/v2/EventosAlumno/eventoMateria`, {unidadEventoMateriaId, alumnoId});
  }

  getUnidadEventos(id: number): Observable<any> {
    return this.http.get<any>(`${API_URL}/api/Unidades/${id}/eventos`);
  }

  getUnidadEventosv2(id: number): Observable<any> {
    return this.http.get<any>(`${API_URL}/api/v2/EventosAlumno/unidadevento/${id}`);
  }

  getMisMaterias(id = 0) {
    return this.http.get(`${API_URL}/api/Materias/alumno/${id}`);
  }

  deleteEvaluacion(idCriterio, unidadEventoMateriaId, alumnoId) {
    return this.http.delete(`${API_URL}/api/v2/EventosAlumno/criterio/borrar/${idCriterio}/alumno/${alumnoId}/unidadeventomateria/${unidadEventoMateriaId}`);
  }

  setFechaCompartir(obj) {
    return this.http.post(`${API_URL}/api/EventosAlumno/materia/fecha/publicar`, obj);
  }

  deleteFechaCompartir(unidadEventoID, mcpID) {
    return this.http.delete(`${API_URL}/api/EventosAlumno/materia/${mcpID}/evento/${unidadEventoID}/fecha/borrar`);
  }

  getEventoCriterioData(reqObj) {
    const url = `${API_URL}/api/eventosalumno/unidadevento/${reqObj.unidadEventoID}/criterio/${reqObj.criterioID}/fecha/${reqObj.fecha}`;
    return this.http.get(url);
  }

  getDetalleAsistencia(materiaID) {
    return this.http.get(`${API_URL}/api/Asistencia/acumulada/materia/${materiaID}`);
  }

  toggleFilters(state) {
    this.subject.next({event: 'toggle-filters', state});
  }

  getObservable() {
    return this.subject.asObservable();
  }

  pdfRetroalimentacion(obj) {
    return this.http.post(`${API_URL}/api/pdfretroalimentacion`,
      obj,
      {headers: {'Content-Type': 'application/json'}, responseType: 'blob'})
      .pipe(map(res => {
        return new Blob([res], {type: 'application/pdf'});
      }));
  }

  // Metodos auxiliares
  filterEventoMaterias(evento, fecha, materiaId) {
    //TODO: Cambiar para la nueva llegada de datos en materias.
    const materiaObj: any[] = evento.materias.filter(item => (materiaId === 0 ||  item.id === materiaId));
    let eventosMaterias = [];
    materiaObj.forEach(element => {
      eventosMaterias = eventosMaterias.concat(element.eventoMaterias.filter(item =>
        (item.fechaAplicar ? fecha.slice(0, 10) === item.fechaAplicar.slice(0, 10) : false)));
    });
    return eventosMaterias;
  }
}
